export enum PartnerType {
	HEALTH = 'HEALTH',
	TEETH = 'TEETH',
}
